import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { generateAlbumId, addAlbum } from '../redux/albumDbSlice';
import { generateRelationUserAlbumId, addRelationUserAlbum} from '../redux/relationUserAlbumDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useAllAlbumDbs from '../hooks/useAllAlbumDbs';

const AddAlbumDialogContent = styled(DialogContent)`
  width: 30vw;
`
const BookNameTextField = styled(TextField)`
  width: 90%;
`

type AddAlbumDialogProps = {
  open: boolean;
  onClose: () => void;
}
const AddAlbumDialog: React.FC<AddAlbumDialogProps> = ({open, onClose}) => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const [albumIds] = useAllAlbumDbs(userId);
  const [value, setValue] = useState('new album');

  const addAlbumExe = () => {
    const albumId = generateAlbumId();
    const ruaId = generateRelationUserAlbumId();
    dispatch(addAlbum({id: albumId, name: value}));
    dispatch(addRelationUserAlbum({id: ruaId, userId: userId || 'no user', albumId: albumId, order: albumIds.length}));
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle></DialogTitle>
      <AddAlbumDialogContent style={{overflow: 'hidden'}}>
        <BookNameTextField label="アルバムの名前" variant="outlined" defaultValue={value} 
                            onChange={(ev) => setValue(ev.target.value)}/>
      </AddAlbumDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => addAlbumExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddAlbumDialog;
